import { OrderBuilderActions, RESET_BUILDER } from '../../../actions/order-builder.actions';
import { ContractActions, ContractActionTypes } from '../actions/contracts.actions';
import { PaymentTerm, RmsContractBalance, ReferenceDocuments } from '@cemex-core/cmx-api';

export interface ContractState {
  availableContracts: {
    [productCode: string]: ReferenceDocuments[];
  };
  balanceCompleted: {
    [contractCode: string]: RmsContractBalance[];
  };
  availablePaymentTerms: PaymentTerm[];
}

export const initialState: ContractState = {
  availableContracts: {},
  balanceCompleted: {},
  availablePaymentTerms: [],
};

export function contractsReducer(state = initialState, action: ContractActions | OrderBuilderActions): ContractState {
  switch (action.type) {
    case ContractActionTypes.LOAD_AVAILABLE_CONTRACTS: {
      return {
        ...state,
        availableContracts: {
          ...state.availableContracts,
          [action.payload.productCode]: action.payload.salesDocuments,
        },
      } as ContractState;
    }
    case ContractActionTypes.BALANCE_COMPLETED: {
      return {
        ...state,
        balanceCompleted: {
          ...state.balanceCompleted,
          ...action.payload,
        },
      } as ContractState;
    }
    case ContractActionTypes.LOAD_CONTRACT_PAYMENT_TERM: {
      return {
        ...state,
        availablePaymentTerms: action.payload,
      } as ContractState;
    }
    case ContractActionTypes.RESET_CONTRACT_BALANCE: {
      return {
        ...state,
        availableContracts: {},
        balanceCompleted: {},
      };
    }
    case RESET_BUILDER:
    case ContractActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
